import {Component, Input} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {Dog} from "../../../../../classes/dog";
import {MatDialog} from "@angular/material";
import {User} from "../../../../../classes/user";
import {kanUsersService} from "../../../../services/services/users";
import {kanDogDialog} from "../../../dialogs/dog-dialog/component";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {kanDogsService} from "../../../../services/services/dogs";
import {kanMembershipDialog} from "../../../dialogs/membership-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-user-dogs',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanUserDogs {
    public dogs: Dog[];
    @Input() private user: User

    constructor(private dialog: MatDialog,
                private authService: kanAuthService,
                private userService: kanUsersService,
                private dogsService: kanDogsService,
                private stateService: StateService) {

    }

    ngOnInit(): void {
        this.getDogs();
    }

    get role(): string {
        return this.authService.role;
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanDogDialog,
            {
                data: {
                    user: this.user
                },
                disableClose: true,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%'
            });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'add') {
                    this.getDogs();
                }
            });
    }

    private getDogs(): void {
        this.userService.getDogs(this.user.id)
            .then((dogs) => {
                this.dogs = dogs;

                this.user.membershipActive = this.dogs.some((dog) => {
                    return dog.membershipActive
                });

            })
            .catch((error) => {
                console.log(error);
            });
    }

    public goToDogDetail(event: any, dog: Dog) {
        this.stateService.go('app.admin.dog', {id: dog.id});
    }

    public editDogDialog(event: any, dog: Dog) {
        let dialogRef = this.dialog.open(kanDogDialog,
            {
                data: {
                    user: this.user,
                    dog: dog
                },
                disableClose: true,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%'
            });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'update') {
                    this.getDogs();
                }
            });
    }

    public editMembershipDialog(event: any, dog: Dog) {
        let dialogRef = this.dialog.open(kanMembershipDialog, {
            data: {
                user: this.user,
                dog: dog
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                console.log(result);
                this.getDogs();
            }
        });
    }

    public removeDog(event: any, dog: Dog) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.dogsService.removeDog(dog)
                    .then((data) => {
                        this.getDogs();
                    });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/dogs/component.ts